import React, { Component } from 'react';
import Nav from '../../common/Nav';
import UpdateEmail from '../UpdateEmail';
import UpdatePassword from '../UpdatePassword';
import { Redirect, withRouter } from 'react-router-dom';
import { Grid, Row, Col, Alert, ControlLabel } from 'react-bootstrap';
import 'react-table/react-table.css';
import './style.css';
import { connect } from 'react-redux';
import { load, clearError, clearSuccess } from './ducks/actions';
export class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      email: '',
      first_name: '',
      last_name: ''
    };
    this.handleErrorDismiss = this.handleErrorDismiss.bind(this);
    this.handleSuccessDismiss = this.handleSuccessDismiss.bind(this);
  }
  componentDidMount() {
    this.props.actions.load();
  }
  handleErrorDismiss() {
    this.props.actions.clearError();
  }
  handleSuccessDismiss() {
    this.props.actions.clearSuccess();
  }
  render() {
    if (!this.props.token) {
      return <Redirect to="/" />;
    }
    var errorMessage;
    if (this.props.error) {
      errorMessage = (
        <Row>
          <Col xs={12}>
            <Alert bsStyle="danger" onDismiss={this.handleErrorDismiss}>
              {this.props.error}
            </Alert>
          </Col>
        </Row>
      );
    }
    var successMessage;
    if (this.props.success) {
      successMessage = (
        <Row>
          <Col xs={12}>
            <Alert bsStyle="success" onDismiss={this.handleSuccessDismiss}>
              {this.props.success}
            </Alert>
          </Col>
        </Row>
      );
    }
    return (
      <div>
        <Nav />
        <div className="container-fluid fe-main-wrapper">
          <div className="fe-main-content">
            <Grid fluid>
              {errorMessage}
              {successMessage}
              <Row>
                <Col xs={12}>
                  <h1 className="page-header">My Account</h1>
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="form-group">
                  <ControlLabel>Name</ControlLabel>
                  <div className="input-group">
                    {this.props.user &&
                      this.props.user.first_name +
                        ' ' +
                        this.props.user.last_name}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="form-group">
                  <ControlLabel>Username</ControlLabel>
                  <div className="input-group">
                    {this.props.user && this.props.user.username}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="form-group">
                  <ControlLabel>Email Address</ControlLabel>
                  <div className="input-group">
                    {this.props.user && this.props.user.email}
                  </div>
                  <div className="input-group">
                    <UpdateEmail />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="form-group">
                  <ControlLabel>Password</ControlLabel>
                  <div className="input-group">
                    <UpdatePassword />
                  </div>
                </Col>
              </Row>
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.profileReducer.error,
    success: state.profileReducer.success,
    user: state.profileReducer.user,
    token: state.loginReducer.token
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      load: () => {
        dispatch(load());
      },
      clearSuccess: () => {
        dispatch(clearSuccess());
      },
      clearError: () => {
        dispatch(clearError());
      }
    }
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Profile)
);



// WEBPACK FOOTER //
// ./src/components/account/Profile/index.js